import { ArrowLeft } from "lucide-react";
import { Link } from "wouter";
import { SiteShell } from "@/components/SiteShell";
import { useLocale } from "@/contexts/LocaleContext";
import { copyFor } from "@shared/bilingualContent";

export default function NotFound() {
  const { locale } = useLocale();
  const ar = locale === "ar";
  const copy = copyFor("notFound",locale);
  return (
    <SiteShell>
      <section className="relative grid min-h-[78vh] place-items-center overflow-hidden pb-24 pt-32">
        <div className="technical-grid absolute inset-0 opacity-20" aria-hidden="true" />
        <div className="point-field absolute inset-0 opacity-20" aria-hidden="true" />
        <div className="narrow-width relative text-center">
          <span className="font-mono text-sm tracking-[0.2em] text-cyan-200">ERROR / 404</span>
          <h1 className="display-lg mt-7">{copy.title}</h1>
          <p className="lede mx-auto mt-7">{copy.body}</p>
          <Link href="/" className="button-primary mt-9"><ArrowLeft className="size-4" />{copy.action}</Link>
        </div>
      </section>
    </SiteShell>
  );
}
